import { Shop } from '@/features/product/choose-pickup-point/types/shop'

import { apiSlice } from '@/shared/api/apiSlice'
import { ServerResponse } from '@/shared/types/common'
import { TDiscountServerResponse, TMarkdownServerResponse } from '@/shared/types/deprecated-types'
import { TRecommendedProducts } from '@/shared/types/deprecated-types'

import { CalculatedProductBonuses, ProductPayments, TProduct } from '../page/types/types'

export const productApi = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getPurchaseBonuses: builder.query<
			ServerResponse<CalculatedProductBonuses>,
			{ productIds: number[]; phone?: string }
		>({
			query: ({ productIds, phone }) => {
				const params = productIds.map(id => `PRODUCTS[]=${id}`).join(`&`)
				const phoneParam = phone ? `&PHONE=${encodeURIComponent(phone)}` : ``

				return {
					url: `/calculate/product/bonus?${params}${phoneParam}`
				}
			}
		}),
		getPayments: builder.query<ServerResponse<ProductPayments>, number>({
			query: productId => ({
				url: `/products/${productId}/payments`
			})
		}),
		getStores: builder.query<ServerResponse<Shop[]>, number>({
			query: productId => ({
				url: `/products/${productId}/stores`
			})
		}),
		getDiscountedProducts: builder.query<ServerResponse<TDiscountServerResponse>, string>({
			query: productKod => ({
				url: `/products/${productKod}/discount`
			})
		}),
		getMarkdownOfProduct: builder.query<ServerResponse<TMarkdownServerResponse>, string>({
			query: productKod => ({
				url: `/products/${productKod}/markdown`
			})
		}),
		getPopularProducts: builder.query<ServerResponse<TProduct[]>, void>({
			query: () => ({
				url: `/home/hits`
			})
		}),
		getRelatedProducts: builder.query<ServerResponse<TRecommendedProducts>, number>({
			query: productId => ({
				url: `/products/${productId}/related`
			})
		}),
		getSimilarProducts: builder.query<ServerResponse<TRecommendedProducts>, number>({
			query: productId => ({
				url: `/products/${productId}/similar`
			})
		}),
		getTradeInDData: builder.query<ServerResponse<any>, number>({
			query: productId => ({
				url: `/products/${productId}/trade-in`
			})
		})
	})
})

export const {
	useGetPurchaseBonusesQuery,
	useGetPaymentsQuery,
	useGetStoresQuery,
	useGetDiscountedProductsQuery,
	useGetMarkdownOfProductQuery,
	useGetPopularProductsQuery,
	useGetRelatedProductsQuery,
	useGetSimilarProductsQuery,
	useGetTradeInDDataQuery
} = productApi
